<wchfs-icon svgIcon="pso:gas_m" color="supporting-3" size="24"></wchfs-icon>
<span class="name">{{ rollingResistance | uppercase }}</span>
